// withRouteTracking.js
import {trackPageView, handleGetSession, staticTime, timeoutPolling} from './trace'
import { pollingPath } from './util'
function withRouteTracking (WrappedComponent) {
  return {
    name: `WithRouteTracking(${WrappedComponent.name || 'Component'})`,
    data () { // 获取原始组件的 data 函数
      const originalData = WrappedComponent.data
      const extendedData = {
        entryTime: null, // 记录进入时间
      }

      // 返回一个新的 data 函数
      return function () {
        return {
          ...originalData ? originalData.call(this) : {}, // 调用原始组件的 data 函数
          ...extendedData,
        }
      }
    },
    // 合并其他选项
    ...WrappedComponent,
    beforeRouteEnter (to, from, next) {
      staticTime()
      if (!localStorage.getItem('sessionId')) {
        handleGetSession(to)
      }
      window && window.sessionStorage.removeItem('traceTitle')
      next(vm => {
        vm.pathToFrom = {
          to,
          from
        }
        vm.entryTime = Date.now() // 记录进入时间
        vm.startTime = Date.now() // 记录进入时间
        localStorage.setItem('startTime', vm.startTime)
        // 一进来先清理视频埋点ID
        setTimeout(() => {
          sessionStorage.removeItem('videoTraceId')
        }, 500)
        localStorage.setItem('vmPathToFrom', JSON.stringify({
          to: { fullPath: to.fullPath, meta: to.meta, name: to.name, path: to.path },
          from: { fullPath: to.fullPath, meta: to.meta, name: to.name, path: to.path }
        }))
        if (pollingPath.includes(to.path) || to.path.indexOf('AIFV') > 0) {
          trackPageView(to, from, vm.startTime) // 上报数据
          sessionStorage.setItem('pollingOver', 'false')
        } else {
          sessionStorage.setItem('pollingOver', 'true')
        }
        // 跳转URL的时候拦截上报数据,微信公众号不给用，做了拦截
        // window.addEventListener('beforeunload', (event) => {
        //   // 执行你的逻辑
        //   // const confirmationMessage = '确定要离开此页面吗？';
        //   // event.returnValue = confirmationMessage; // 标准规范
        //   // return confirmationMessage;              // 部分旧浏览器可能需要
        // })
      })
    },
    // beforeRouteUpdate (to, from, next) {
    //   console.log('beforeRouteUpdate')
    //   this.entryTime = Date.now() // 更新进入时间
    // },
    beforeRouteLeave (to, from, next) {
      console.log('beforeRouteLeave')
      if (this.beforeRouteLeaveCustom) {
        this.beforeRouteLeaveCustom().then(vaild => {
          if (vaild) {
            // const exitTime = Date.now() // 记录离开时间
            // const duration = exitTime - this.entryTime // 计算停留时间
            sessionStorage.setItem('pollingOver', 'true')
            trackPageView(to, from, this.startTime, 'isLeave') // 上报数据
            sessionStorage.removeItem('journeyPageViewId')
            clearTimeout(timeoutPolling)
            next()
          } else {
            next(false)
          }
        })
      } else {
        // const exitTime = Date.now() // 记录离开时间
        // const duration = exitTime - this.entryTime // 计算停留时间
        sessionStorage.setItem('pollingOver', 'true')
        trackPageView(to, from, this.startTime, 'isLeave') // 上报数据
        sessionStorage.removeItem('journeyPageViewId')
        clearTimeout(timeoutPolling)
        next()
      }
    },
    render (h) {
      return h(WrappedComponent, {
        props: this.$props,
        on: this.$listeners,
      })
    },
  }
}

export default withRouteTracking



// WEBPACK FOOTER //
// ./src/utils/withRouteTracking.js